import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

export const HomePage: React.FC = () => (
  <Card>
    <Title level={1}>TÍNH NĂNG SẼ PHÁT TRIỂN SAU</Title>
  </Card>
);

